import Api from "shared/service/api/api";

// actions
export const LOAD_LANDINGS = "loadLandings";
export const LOAD_TEMPLATES = "loadTemplates";

//mutations
export const SET_LANDINGS = "setLandings";
export const SET_TEMPLATES = "setTemplates";

const state = {
  landings: {
    list: [],
    page: 1,
    page_count: 1,
  },
  datasets: {
    templates: [],
  },
};

const actions = {
  [LOAD_LANDINGS]({ commit }, { page = 1, search = "" }) {
    Api.project.landing
      .all(page, search)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_LANDINGS, response.data);
      })
      .catch((e) => e);
  },
  [LOAD_TEMPLATES]({ commit }) {
    Api.project.landing
      .templates()
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_TEMPLATES, response.data);
      })
      .catch((e) => e);
  },
};

const mutations = {
  [SET_LANDINGS](state, { list, page, page_count }) {
    state.landings.list = list;
    state.landings.page = page;
    state.landings.page_count = page_count;
  },
  [SET_TEMPLATES](state, templates) {
    state.datasets.templates = templates;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
